import React from "react";

function VacacionesFormulario() {
  const hoy = new Date();
  const anioActual = hoy.getFullYear();
  const mesActual = hoy.getMonth(); // 0 = enero, 11 = diciembre

  // +1 solo durante diciembre
  const anioReactivacion =
    mesActual === 11 ? anioActual + 1 : anioActual;

  return (
<div className="row justify-content-center">
  <div className="col-12 col-md-9 col-lg-8 mt-4">
    <div className="card border-warning">
      <div className="card-body text-center">

        <p className="fs-6 mb-2">
          Informamos que las solicitudes de
          <strong> desbloqueo de equipos</strong> se encuentran pausadas
          durante el receso de verano.
        </p>

        <p className="fs-5 fw-semibold text-warning mb-3">
          Reactivación prevista:
          <br />
          <span className="fs-4">
            1 de febrero de {anioReactivacion}
          </span>
        </p>

        <p className="text-muted mb-0">
          Agradecemos su comprensión.
        </p>

      </div>
    </div>
  </div>
</div>

  );
}

export default VacacionesFormulario;
